import { HTMLAttributes } from 'react';
import { SectionsType } from '../types';
import Text from '~/components/Text';
import * as Styles from './styles';

interface IContextMenuProps {
  sections: SectionsType;
  onClick(): void;
  fixedAttributes: HTMLAttributes<HTMLDivElement>;
}

const ContextMenu = ({ sections, onClick, fixedAttributes }: IContextMenuProps) => (
  <Styles.DropdownWrapper className="v-d-flex has-y-scroll" {...fixedAttributes}>
    {sections.map((eachSection, index) => (
      <Styles.EachSection key={eachSection.key ?? `${eachSection.label}` ?? index} className="pt-8">
        {eachSection.label && <Text className="semi-bold">{eachSection.label}</Text>}
        {eachSection.options.map(eachOption => {
          const isVisible = eachOption.isVisible ?? true;
          if (!isVisible) {
            return null;
          }
          const isEnabled = eachOption.isEnabled ?? true;
          return (
            <Styles.ListItem
              key={`${eachOption.text}`}
              className={`align-center ${isEnabled ? 'cursor-pointer' : 'cursor-default'}`}
              onClick={event => {
                event.stopPropagation();
                if (isEnabled) {
                  eachOption.onClick?.();
                  onClick();
                }
              }}
            >
              {eachOption.icon ? (
                <Styles.IconContainer>{eachOption.icon}</Styles.IconContainer>
              ) : null}
              <Styles.ItemData
                variant={eachOption.color}
                className="full-width"
                isEnabled={isEnabled}
              >
                {eachOption.text}
              </Styles.ItemData>
            </Styles.ListItem>
          );
        })}
      </Styles.EachSection>
    ))}
  </Styles.DropdownWrapper>
);

export default ContextMenu;
